import type { PropsWithChildren} from 'react';
import { useRef } from 'react';

import { DialogBody } from './body/DialogBody';
import { DialogButtonGroup } from './button-group/DialogButtonGroup';
import styles from './Dialog.module.scss';
import { DialogHeader } from './header/DialogHeader';

type DialogVariant = 'compact' | 'long';

type DialogSize = 'small' | 'medium' | 'large';

interface DialogProps {
  variant?: DialogVariant;
  size?: DialogSize;
}

interface DialogHandle {
  open(): void;
  close(): void;
}

const Dialog = ({
  variant = 'compact',
  size = 'medium',
  children,
}: PropsWithChildren<DialogProps>) => {
  return (
    <div className={styles.container} data-variant={variant} data-size={size}>
      {children}
    </div>
  );
};

Dialog.Header = DialogHeader;
Dialog.Body = DialogBody;
Dialog.ButtonGroup = DialogButtonGroup;

const useDialog = () => {
  return useRef<DialogHandle>(null);
};

interface DialogContext {
  onAction: (action: string, data?: any) => void;
}

export {
  Dialog,
  useDialog,
  type DialogContext,
  type DialogVariant,
  type DialogSize,
  type DialogProps,
};
